import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteTenuredProfessorComponent } from './website-tenured-professor.component'
import { SharedModule } from '../shared/shared.module'



@NgModule({
  declarations: [WebsiteTenuredProfessorComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [WebsiteTenuredProfessorComponent]
})
export class WebsiteTenuredProfessorModule { }
